// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MpKlrxBy_xkhiJtlc0YT {
  padding: 0;
  display: flex;
  flex-direction: column;
  grid-gap: 0.5rem;
  gap: 0.5rem;
}

.MdhW_XRfGYMYS8nrBchU {
  padding: 0.5rem 1rem;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  -webkit-text-decoration-color: var(--white);
          text-decoration-color: var(--white);
  max-width: 19.125rem;
  grid-gap: 0.5rem;
  gap: 0.5rem;
}

.MdhW_XRfGYMYS8nrBchU:hover {
  background-color: var(--business-page-v3-dropdown-hover);
  border-radius: 2.5rem;
  width: 100%;
  -webkit-text-decoration-color: var(--business-page-v3-dropdown-hover);
          text-decoration-color: var(--business-page-v3-dropdown-hover);
  color: var(--business-page-v3-dropdown-text-hover);
}

.oS8MwWx8zvHEyvyRc_Lx {
  visibility: hidden;
  min-width: 1.5rem;
}

.MdhW_XRfGYMYS8nrBchU:hover .oS8MwWx8zvHEyvyRc_Lx {
  visibility: visible
}

.MdhW_XRfGYMYS8nrBchU:hover .oS8MwWx8zvHEyvyRc_Lx * {
    stroke: var(--business-page-v3-dropdown-text-hover);
  }

.s0RoFFdOHwzvUh5ap7Lk {
  display: flex;
  align-items: center;
  font-size: 1rem;
  grid-gap: 0.5rem;
  gap: 0.5rem;
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 2.5rem;
}

.OwFoqdDJLyOwADEd7gPa {
  background-color: var(--white);
}

.nnmQHwMHrkB4cixjX5J0 {
  margin-right: 0.5rem;
  color: var(--header-text-color-v2);
  white-space: nowrap;
}

.dEaF6iEa0aLkM0VBy549 {
  color: var(--header-category-highlight-color-v2);
  background-color: var(--white);
}

.aJtBClRdMCMPspThqnjk {
  width: -moz-fit-content;
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/HeaderDropDown/HeaderDropDown.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gBAAQ;EAAR,WAAQ;AACV;;AAEA;EACE,oBAAiB;EACjB,eAAe;EACf,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2CAAmC;UAAnC,mCAAmC;EACnC,oBAAgB;EAChB,gBAAQ;EAAR,WAAQ;AACV;;AAEA;EACE,wDAAwD;EACxD,qBAAmB;EACnB,WAAW;EACX,qEAA6D;UAA7D,6DAA6D;EAC7D,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,iBAAe;AACjB;;AAEA;EACE;AAKF;;AAHE;IACE,mDAAmD;EACrD;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAQ;EAAR,WAAQ;EACR,eAAe;EACf,oBAAiB;EACjB,qBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":[".dropdownList {\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.dropdownItem {\n  padding: 8px 16px;\n  font-size: 16px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  text-decoration-color: var(--white);\n  max-width: 306px;\n  gap: 8px;\n}\n\n.dropdownItem:hover {\n  background-color: var(--business-page-v3-dropdown-hover);\n  border-radius: 40px;\n  width: 100%;\n  text-decoration-color: var(--business-page-v3-dropdown-hover);\n  color: var(--business-page-v3-dropdown-text-hover);\n}\n\n.arrow {\n  visibility: hidden;\n  min-width: 24px;\n}\n\n.dropdownItem:hover .arrow {\n  visibility: visible;\n\n  & * {\n    stroke: var(--business-page-v3-dropdown-text-hover);\n  }\n}\n\n.button {\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  gap: 8px;\n  cursor: pointer;\n  padding: 8px 16px;\n  border-radius: 40px;\n}\n\n.expandedButton {\n  background-color: var(--white);\n}\n\n.dropDownTitle {\n  margin-right: 8px;\n  color: var(--header-text-color-v2);\n  white-space: nowrap;\n}\n\n.expandedDropDownTitle {\n  color: var(--header-category-highlight-color-v2);\n  background-color: var(--white);\n}\n\n.wrapper {\n  width: fit-content;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownList": `MpKlrxBy_xkhiJtlc0YT`,
	"dropdownItem": `MdhW_XRfGYMYS8nrBchU`,
	"arrow": `oS8MwWx8zvHEyvyRc_Lx`,
	"button": `s0RoFFdOHwzvUh5ap7Lk`,
	"expandedButton": `OwFoqdDJLyOwADEd7gPa`,
	"dropDownTitle": `nnmQHwMHrkB4cixjX5J0`,
	"expandedDropDownTitle": `dEaF6iEa0aLkM0VBy549`,
	"wrapper": `aJtBClRdMCMPspThqnjk`
};
export default ___CSS_LOADER_EXPORT___;
